import React from 'react';
import { useAppDispatch } from '../../redux/hooks';
import { play } from '../../redux/slices/ui';
export default function Overlay() {
    const dispatch = useAppDispatch();
    return (React.createElement("div", { className: "overlay" },
        React.createElement("button", { id: "playpause", className: "overlay-button", "aria-label": "Play", onClick: () => dispatch(play()) }, ' ')));
}
//# sourceMappingURL=Overlay.js.map